import { Link } from "@tanstack/react-router";
import { FacebookIcon, InstagramIcon } from "@/components/icons";
import { Image } from "@/components/image";
import { ACTIVITIES__NEW__, OPENING_HOURS } from "@/lib/constants";

export function Footer() {
  return (
    <>
      <div className="bg-background pt-20 pb-32">
        <footer className="container mx-auto grid max-w-7xl grid-cols-1 gap-8 px-4 md:grid-cols-2 xl:grid-cols-4">
          <div className="space-y-8">
            <Link className="block" to="/">
              <Image
                alt="Logo"
                className="h-10 w-full object-contain md:w-fit"
                height={40}
                src="/images/logo.png"
                width={210}
              />
            </Link>
            <div>
              <h3 className="mb-2 font-bold text-2xl">Kontakt</h3>
              <p>TOMA 1807 GmbH & Co KG</p>
              <p>ALTE PAPIERFABRIK</p>
              <p>Friedrich-Ebert-Str. 130</p>
              <p>42117 Wuppertal</p>
              <p className="mt-2">
                Telefon:{" "}
                <a className="underline" href="tel:+492023179995">
                  0202 / 3179995
                </a>
              </p>
              <p>
                E-Mail:{" "}
                <a className="underline" href="mailto:buchen@altepapierfabrik.eu">
                  buchen@altepapierfabrik.eu
                </a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-2xl">Unser Angebot</h3>
            <ul className="space-y-2">
              {Object.values(ACTIVITIES__NEW__).map((activity) => (
                <li key={activity.key}>
                  <Link className="hover:underline" {...activity.link}>
                    {activity.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-2xl">Social Media</h3>
            <div className="flex gap-4">
              <a
                aria-label="Alte Papierfabrik Instagram"
                className="hover:opacity-80"
                href="https://instagram.com/altepapierfabrik_wuppertal"
                rel="noopener noreferrer"
                target="_blank"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-2xl">Öffnungszeiten</h3>
            <div className="grid grid-cols-2 gap-x-4 gap-y-2">
              {OPENING_HOURS.map((day) => (
                <>
                  <span className="font-medium" key={`${day.key}-label`}>
                    {day.label}
                  </span>
                  <span key={`${day.key}-hours`}>{day.hours}</span>
                </>
              ))}
            </div>
          </div>
        </footer>
      </div>
      <div className="bg-accent px-4 py-2 pb-26 text-accent-foreground md:pb-2">
        <div className="container mx-auto flex max-w-7xl flex-col items-center justify-between lg:flex-row">
          <div className="flex flex-col gap-1 md:flex-row">
            <p>© {new Date().getFullYear()} TOMA 1807 GmbH & Co KG</p>
            <p className="hidden md:block">|</p>
            <p>
              Built by{" "}
              <a className="underline" href="https://clebek.dev">
                Carsten Lebek
              </a>
            </p>
          </div>
          <div className="flex items-center gap-1">
            <Link className="underline" to="/impressum">
              Impressum
            </Link>
            <span>|</span>
            <Link className="underline" to="/datenschutz">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
